export var GROUPS_IDS;
(function (GROUPS_IDS) {
    GROUPS_IDS[GROUPS_IDS["IDP"] = 134] = "IDP";
    GROUPS_IDS[GROUPS_IDS["TEST_IDP_GROUP"] = 100] = "TEST_IDP_GROUP";
})(GROUPS_IDS || (GROUPS_IDS = {}));
